/**
 * dateUtils.js — Centralized date formatting for CRM
 * Indian Standard: dd/mm/yyyy
 *
 * IMPORTANT: These are DISPLAY-only functions.
 * - All <input type="date"> fields continue to use yyyy-mm-dd (HTML standard, backend expects this)
 * - todayStr() / tomorrow() / toISOString() — untouched, used for API calls
 * - toLocaleString() for month names (e.g. "March 2026") — untouched, not date display
 */

/**
 * Format date as dd/mm/yyyy
 * e.g. "02/03/2026"
 */
export const fmtDate = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d)) return '—';
  const dd   = String(d.getDate()).padStart(2, '0');
  const mm   = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

/**
 * Format date+time as dd/mm/yyyy hh:mm
 * e.g. "02/03/2026 14:30"
 */
export const fmtDateTime = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d)) return '—';
  const dd   = String(d.getDate()).padStart(2, '0');
  const mm   = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  const hh   = String(d.getHours()).padStart(2, '0');
  const min  = String(d.getMinutes()).padStart(2, '0');
  return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
};

/**
 * Format date as "02 Mar 2026" (short month display)
 * Used in tables/cards where compact display needed
 */
export const fmtDateShort = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d)) return '—';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};
